import { useTranslation } from 'react-i18next';
import { SUPPORTED_LNGS, type AppLocale } from './index';
import { localizedPath } from './slugMap';

/**
 * Locale ativo no app, normalizado pra um dos 3 suportados.
 * Tolera variações (`en-US` → `en`, `pt` → `pt-BR`). Fallback `pt-BR`.
 */
export function useCurrentLocale(): AppLocale {
  const { i18n } = useTranslation();
  const lng = i18n.language || 'pt-BR';
  const exact = SUPPORTED_LNGS.find((l) => l === lng);
  if (exact) return exact;
  const base = lng.split('-')[0];
  return (SUPPORTED_LNGS.find((l) => l.split('-')[0] === base) ?? 'pt-BR') as AppLocale;
}

/**
 * Retorna uma função `path(routeId)` que monta o caminho da rota no idioma
 * ativo — ex.: no locale `en`, `path('sobre')` → `/en/about`; em `pt-BR`,
 * `path('sobre')` → `/sobre`. Usar em todos os links internos i18n-izados.
 */
export function useLocalizedPath(): (routeId: string) => string {
  const locale = useCurrentLocale();
  return (routeId: string) => localizedPath(routeId, locale);
}
